import Card from '../Card'
import { createUseStyles } from 'react-jss'
import { Colors } from '../../constants/colors'
import { PayrollFileRow } from '../../redux/types'
import { formatMoney } from '../../utils/moneyHelper'
import Link from '../Link';

interface Props {
  rows: PayrollFileRow[]
}

const PayrollFileRowList = ({ rows }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
        <div className={styles.cell}>
          <h6>External id</h6>
        </div>
        <div className={styles.cell}>
          <h6>Employee</h6>
        </div>
        <div className={styles.cell}>
          <h6>Net amount</h6>
        </div>
      </Card>
    )    
  }

  const renderListItems = () => {
    return rows?.map((item, index) => {
      return (
        <Card key={`row_${index}`} className={`${styles.container} card`}>
          <div className={styles.cell}>
            {item.employeeExternalId}
          </div>
          <div className={styles.cell}>
            <Link to={`/employees/${item.employeeId}`}>{item.employeeName}</Link>
          </div>
          <div className={styles.cell}>
            {formatMoney(item.netAmount)}
          </div>
        </Card>
      )
    })
  }

  return (
    <div>
      {renderHeader()}
      {renderListItems()}
    </div>
  )
}

export default PayrollFileRowList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0'
  },
  header: {
    margin: '30px 0 20px 0',
  },
  cell: {
    flex: 1,
    padding: '0px 10px'
  }
})
